import { useAuth0 } from '@auth0/auth0-react';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook.tsx';
import { queryKeys } from '@queries/keys.ts';
import { useQuery } from '@tanstack/react-query';
import { CapabilitiesSelectDto, CapabilitySelectDto } from '../types/api.types';

export const useGetCapabilities = () => {
  const { apiGet } = useApi();
  const { isAuthenticated } = useAuth0();
  const enabled = Boolean(isAuthenticated);

  return useQuery<CapabilitySelectDto[], ApiErrorWrapper>({
    enabled,
    queryFn: async () => {
      const result = await apiGet<CapabilitiesSelectDto>({
        path: '/v1/data/capabilities',
      });
      return result.capabilities;
    },
    queryKey: enabled ? queryKeys.capability.getCapabilities : queryKeys.placeholders.default,
  });
};
